import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\tmax-width: ", ";\n\t\t\tposition: absolute;\n\t\t\ttop: 16%;\n\t\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tleft: 50%;\n\t\tmax-width: 100%;\n\t\topacity: 0;\n\t\toutline: none;\n\t\tperspective: 800px;\n\t\tposition: relative;\n\t\ttop: ", ";\n\t\ttransform: translate3d(-50%, ", ", 0);\n\t\ttransform-origin: top center;\n\t\ttransition: ", ";\n\t\twidth: 100%;\n\n\t\t@media (min-height: 40em) {\n\t\t\ttop: ", ";\n\t\t}\n\n\t\t", "\n\n\t\t&[data-enter] {\n\t\t\topacity: 1;\n\t\t\ttransform: translate3d(-50%, 0, 0);\n\n\t\t\t&[data-underlayer] {\n\t\t\t\ttransform: translate3d(-50%, -10px, 0) scale(0.95);\n\t\t\t\ttransform-origin: top center;\n\t\t\t}\n\t\t}\n\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, cx, getBreakpoint, ui } from '@wp-g2/styles';
import React from 'react';
import { BaseModal } from '../BaseModal';
import { Card } from '../Card';
export { useModalContext } from './Modal.Context';
var MODAL_SIZES = {
  lg: 720,
  md: 500,
  sm: 400
};

function Modal(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'Modal'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      _useContextSystem$siz = _useContextSystem.size,
      size = _useContextSystem$siz === void 0 ? 'md' : _useContextSystem$siz,
      _useContextSystem$tra = _useContextSystem.transitionDuration,
      transitionDuration = _useContextSystem$tra === void 0 ? 200 : _useContextSystem$tra,
      _useContextSystem$tra2 = _useContextSystem.transitionTimingFunction,
      transitionTimingFunction = _useContextSystem$tra2 === void 0 ? 'ease-in-out' : _useContextSystem$tra2,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className", "size", "transitionDuration", "transitionTimingFunction"]);

  var maxWidth = MODAL_SIZES[size] || MODAL_SIZES.md;
  var baseStyles = css(_templateObject(), ui.space(4), ui.space(5), "\n\topacity " + transitionDuration + "ms " + transitionTimingFunction + ",\n\t\t\ttransform " + transitionDuration + "ms " + transitionTimingFunction + "\n\t", ui.space(4), getBreakpoint('md')(_templateObject2(), ui.value.px(maxWidth)));
  var classes = cx(baseStyles, className);

  var modalProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    size: size,
    transitionTimingFunction: transitionTimingFunction
  });

  return /*#__PURE__*/React.createElement(BaseModal, Object.assign({
    className: classes,
    ref: forwardedRef
  }, modalProps), /*#__PURE__*/React.createElement(Card, {
    elevation: 4
  }, children));
}

export default contextConnect(Modal, 'Modal');